export default            
    {
        path:'/plan',
        name:'行动计划',
        redirect:'/plan/main',
        component:()=>import('../views/plan/index'),
        meta:{requireAuth:true,roles:['student']},
        children:[
            {
                path:'/plan/main',
                name:'行动计划主页',
                component:()=>import('../views/plan/main'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/plan/month',
                name:'月计划',
                component:()=>import('../views/plan/month'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/plan/week',
                name:'周计划',
                component:()=>import('../views/plan/week'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/plan/date',
                name:'日计划',
                component:()=>import('../views/plan/date'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/plan/replay',
                name:'学生复盘',
                component:()=>import('../views/plan/replay'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/plan/pdf',
                name:'计划表',
                component:()=>import('../views/plan/pdf'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/plan/planHistoryRecord',
                name:'行动计划历史记录',
                component:()=>import('../views/plan/planHistoryRecord'),
                meta:{requireAuth:true,roles:['student']},
            }
        ]
    }